

<div id="collapse{{item}}" class="accordion-body collapse expanded_data">
    <div class="accordion-inner info_table">
       <div class="accordion" id="accordion21" *ngFor="let mainitem of VendorConsDocDropList;let mainindex=index;">
          <div class="accordion-group accordion-level1">
             <div class="accordion-heading closed">
                <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion21"
                href="#Doc{{mainitem.SNO}}">
                {{mainitem.DocCategory}} {{mainitem.emailLogId}}
                </a>
             </div>
             <div id="Doc{{mainitem.SNO}}" class="accordion-body collapse in">
                <div class="accordion-inner">
                   <div class="table_wrap">
                      <div class="custom_table_head">
                         <div class="custom_tr row">
                            <div class="custom_th colw-40">Document</div>
                            <div class="custom_th colw-14">Status</div>
                            <div class="custom_th colw-14">Signed</div>
                            <div class="custom_th colw-18" *ngIf="mainitem.DocCategory=='Ascendion Document'">View</div>
                            <div class="custom_th colw-14">Download</div>
                            <div class="custom_th colw-18" *ngIf="mainitem.DocCategory!='Ascendion Document'">Uploaded File Name</div>
                         </div>
                      
                         <div class="custom_tr row" *ngFor="let item of mainitem.DocList;let currentindex=index;">
                            <div class="custom_td colw-40">
                              {{item.DocName}}
                            </div>
                            <div class="custom_td colw-14 status_sign text-center">
                              {{item.DocuSignStatus}}
                            </div>
                            <div class="custom_td colw-14 text-center">
                              {{item.Signed}}
                            </div>
                            <div class="custom_td colw-18 text-center" *ngIf="mainitem.DocCategory=='Ascendion Document'">
                               <!-- <span class="modal_open" data-modalname="" data-tooltip="View Document" data-tooltip-location="bottom">
                                 <a *ngIf="item.FileContent!=null && item.DocuSignStatus=='Executed'">
                                 <img  src="../assets/images/icons/ic-doc-view.svg" alt="ic-doc-view" (click)="DownloadFile(item.UploadedFileName,item.FileContent,'0')" />
                                 </a></span>
                                 <span class="modal_open" data-modalname=""  data-tooltip="View Document" data-tooltip-location="bottom">
                                    <a *ngIf="item.FileContent==null && item.DocuSignStatus=='Signed'">
                                    <img  src="../assets/images/icons/ic-doc-view.svg" alt="ic-doc-view" (click)="DownloadFileSigned(item.documentId,item.envelopId,item.UploadedFileName,'0')" />
                                    </a></span> -->

                                    <span class="modal_open" data-modalname=""  data-tooltip="View Document" data-tooltip-location="bottom">
                                       <a>
                                       <img  src="../assets/images/icons/ic-doc-view.svg" alt="ic-doc-view" (click)="CommonDownloadFile(item.documentId,item.envelopId,item.UploadedFileName,item.FileContent,item.DocuSignStatus,'0')" />
                                       </a></span>
                            </div>
                            <div class="custom_td colw-14 text-center">
                             
                                           <span data-tooltip="Download Document" data-tooltip-location="bottom"><a>
                                             <img src="../assets/images/icons/ic-download-latest.svg"
                                                 alt="ic-download-latest" (click)="CommonDownloadFile(item.documentId,item.envelopId,item.UploadedFileName,item.FileContent,item.DocuSignStatus,'1')"  data-tooltip="Download Document" data-tooltip-location="bottom"/></a></span>
                                       
                            </div>
                            <div class="custom_td colw-18 text-center" *ngIf="mainitem.DocCategory!='Ascendion Document'">
                            {{item.UploadedFileName}}
                            </div>
                         </div>
                      
                      </div>
                   </div> 
                </div>
             </div>
          </div>
       </div>
    </div>
 </div>
